export default __webpack_public_path__ + "static/team-member-2-857be90cfe039add35ab5dad86532b0c.png";